import { action, computed, makeObservable, observable } from 'mobx';
import { Map } from 'ol';
import { EventsKey } from 'ol/events';
import { FeatureLike } from 'ol/Feature';
import { unByKey } from 'ol/Observable';
import { Pixel } from 'ol/pixel';

export class MapContextMenuController {
  @observable private _pixel?: Pixel = undefined;
  @observable private _position?: GeoJSON.Position = undefined;
  @observable private _features?: FeatureLike[] = undefined;

  private _mapEventsKeys: EventsKey[] = [];

  constructor(private _map: Map) {
    makeObservable<MapContextMenuController>(this);
  }

  @computed get pixel() {
    return this._pixel;
  }

  @computed get position() {
    return this._position;
  }

  @computed get features() {
    return this._features;
  }

  @computed get opened() {
    return !!this._pixel && !!this._position;
  }

  @action close() {
    this._position = undefined;
    this._pixel = undefined;
  }

  @action open(pixel: Pixel, positionXY: GeoJSON.Position) {
    this._position = positionXY;
    this._pixel = pixel;
    this._features = this._map.getFeaturesAtPixel(pixel);
  }

  bind = () => {
    const mapElement = this._map.getViewport();

    mapElement.addEventListener('contextmenu', this._handleContextMenuEvent);
    mapElement.addEventListener('mousedown', this._handleClose);
    // TODO: Добавить закрытие на blur
    //  mapElement.addEventListener('blur', this._handleClose);

    const keys = this._map.getView().on('change', () => this.close());

    this._mapEventsKeys = Array.isArray(keys) ? keys : [keys];

    return this.unbind;
  };

  unbind = () => {
    this.close();

    const mapElement = this._map.getViewport();

    mapElement.removeEventListener('contextmenu', this._handleContextMenuEvent);
    mapElement.removeEventListener('mousedown', this._handleClose);

    unByKey(this._mapEventsKeys);
    this._mapEventsKeys = [];
  };

  private _handleContextMenuEvent = (e: MouseEvent) => {
    e.preventDefault();

    this.open(this._map.getEventPixel(e), this._map.getEventCoordinate(e));
  };

  private _handleClose = (e: Event) => {
    e.preventDefault();

    this.close();
  };
}
